"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeaderArea = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HeaderArea = (param)=>{
    let { banner, pageNavigation, breadcrumbs } = param;
    const theme = (0, _mui.useTheme)();
    const { getTestId } = (0, _testidGenerator.default)();
    const mappedCategoryBarItems = (0, _react.useMemo)(()=>(0, _utils.mapCategoryBarFromPageNavigation)(pageNavigation), [
        pageNavigation
    ]);
    const mappedBreadcrumbs = (0, _react.useMemo)(()=>(0, _utils.mapBreadcrumbsFromBreadcrumbLinks)(breadcrumbs), [
        breadcrumbs
    ]);
    const categoryBarProps = (0, _react.useMemo)(()=>{
        var _mappedCategoryBarItems_links;
        return {
            fontColor: theme.palette.primary.dark,
            activeLink: mappedCategoryBarItems === null || mappedCategoryBarItems === void 0 ? void 0 : mappedCategoryBarItems.active,
            linkData: (_mappedCategoryBarItems_links = mappedCategoryBarItems === null || mappedCategoryBarItems === void 0 ? void 0 : mappedCategoryBarItems.links) !== null && _mappedCategoryBarItems_links !== void 0 ? _mappedCategoryBarItems_links : [],
            useOnlyExternalActiveLink: true
        };
    }, [
        mappedCategoryBarItems === null || mappedCategoryBarItems === void 0 ? void 0 : mappedCategoryBarItems.active,
        mappedCategoryBarItems === null || mappedCategoryBarItems === void 0 ? void 0 : mappedCategoryBarItems.links,
        theme.palette.primary.dark
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.PLP_HEADER_AREA),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Inner, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.TopBanner, {
                    title: banner.headline,
                    breadcrumbs: mappedBreadcrumbs,
                    backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
                        backendColor: banner.backgroundStorybookColor,
                        theme
                    }),
                    textColor: theme.palette.text.primary,
                    imageUrl: banner.imageUrl,
                    extraLongHeadline: banner.extraLongHeadline,
                    categoryBarProps: categoryBarProps
                }, banner.headline)
            }),
            banner.text ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.IntroTextStyled, {
                text: banner.text
            }) : null
        ]
    });
};
exports.HeaderArea = HeaderArea;
